import { call, put, takeLatest } from "redux-saga/effects";
import { User, Auth } from "../../models";
import { FORM_CLEAR, FORM_END_PROCESSING } from "../../lib";
import { notification, navigate, eventEmitter } from "../../services";
import {
    USER_SET,
    USER_CLEAR,
    USER_CHK_AUTH,
    USER_CHK_AUTH_STATUS,
    USER_LOGOUT,
    USER_SAVE,
    USER_CREATE,
} from "./actions";
import { DOC_CLEAR } from "../docs/actions";
import { PAGE_CLEAR } from "../pages/actions";
import { DOC_USER_CLEAR } from "../doc_users/actions";
import { STATUS_USER_LOADED } from "../status/actions";
import { EVT_USER_REGISTER } from "../../components/Forms/RegisterForm";
import { AxiosResponse } from "axios";

function* checkAuthStatus(_action: { type: typeof USER_CHK_AUTH_STATUS }) {
    try {
        const { data }: AxiosResponse<any> = yield call([Auth, "fetch"], "");
        yield put({
            type: USER_SET,
            payload: data,
        });
    } catch (e) {
        console.log(e);
    } finally {
        yield put({
            type: STATUS_USER_LOADED,
            payload: true,
        });
    }
}

function* onCheckAuthStatus() {
    yield takeLatest(USER_CHK_AUTH_STATUS, checkAuthStatus);
}

function* checkAuth(action: { type: typeof USER_CHK_AUTH; payload: any }) {
    try {
        const { data }: AxiosResponse<any> = yield call(
            [Auth, "create"],
            action.payload
        );
        yield put({
            type: USER_SET,
            payload: data,
        });
    } catch (e) {
        notification.apiError(e);
    } finally {
        eventEmitter.emit(FORM_END_PROCESSING);
    }
}

function* onCheckAuth() {
    yield takeLatest(USER_CHK_AUTH, checkAuth);
}

function* logoutUser(action: { type: typeof USER_LOGOUT }) {
    try {
        yield call([Auth, "destroy"], "");
        yield put({ type: USER_CLEAR });
        yield put({ type: DOC_CLEAR });
        yield put({ type: PAGE_CLEAR });
        yield put({ type: DOC_USER_CLEAR });
        // navigate.to("/app/");
        window.location.assign("/");
    } catch (e) {}
}

function* onLogoutUser() {
    yield takeLatest(USER_LOGOUT, logoutUser);
}

function* createUser(action: {
    type: typeof USER_CREATE;
    payload: {
        redirect: boolean;
        [x: string]: any;
    };
}) {
    try {
        const {
            data,
        }: AxiosResponse<{
            errors?: Array<any>;
        }> = yield call([User, "create"], action.payload);
        yield put({
            type: USER_SET,
            payload: data,
        });

        const { errors } = data;
        if (errors && errors.length > 0) {
            eventEmitter.emit(FORM_END_PROCESSING);
            return notification.set(errors[0], "f");
        }

        eventEmitter.emit(FORM_END_PROCESSING);
        eventEmitter.emit(FORM_CLEAR);
        eventEmitter.emit(EVT_USER_REGISTER);

        if (action.payload.redirect) {
            navigate.to("/app/docs");
        }

        notification.set("registerForm.success", "s");
    } catch (e) {
        notification.apiError(e);
    } finally {
        eventEmitter.emit(FORM_END_PROCESSING);
    }
}

function* onCreateUser() {
    yield takeLatest(USER_CREATE, createUser);
}

function* saveUser(action: { type: typeof USER_SAVE; payload: any }) {
    try {
        const { data }: AxiosResponse<any> = yield call(
            [User, "save"],
            action.payload,
            ""
        );
        yield put({
            type: USER_SET,
            payload: data,
        });
    } catch (e) {
        notification.apiError(e);
    } finally {
        eventEmitter.emit(FORM_END_PROCESSING);
    }
}

function* onSaveUser() {
    yield takeLatest(USER_SAVE, saveUser);
}

export {
    onCheckAuth,
    onCheckAuthStatus,
    onLogoutUser,
    onCreateUser,
    onSaveUser,
};
